import { useMemo } from "react"

import type { VaasThumbnail } from "~/v2/types/vaas"
import getCloudinaryThumbnailUrl from "~/v2/utils/get-cloudinary-thumbnail-url"

const useThumbnail = (thumbnail?: VaasThumbnail | null, size = 280) => {
  return useMemo(() => {
    if (!thumbnail || Object.keys(thumbnail).length === 0) {
      return null
    }

    return getCloudinaryThumbnailUrl(thumbnail, size)
  }, [thumbnail, size])
}

export default useThumbnail
